import { gql } from '@apollo/client';

export const COST_FRAGMENT = gql`
    fragment CostFrament on CostPreviewResponse {
        credits
        remainingCredits
        unavailabilityReason
    }
`;
